/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterCourseTypeAddPost } from '../fn/course-type/api-master-course-type-add-post';
import { ApiMasterCourseTypeAddPost$Params } from '../fn/course-type/api-master-course-type-add-post';
import { apiMasterCourseTypeDeleteGet } from '../fn/course-type/api-master-course-type-delete-get';
import { ApiMasterCourseTypeDeleteGet$Params } from '../fn/course-type/api-master-course-type-delete-get';
import { apiMasterCourseTypeEditPost } from '../fn/course-type/api-master-course-type-edit-post';
import { ApiMasterCourseTypeEditPost$Params } from '../fn/course-type/api-master-course-type-edit-post';
import { apiMasterCourseTypeGetActiveGet } from '../fn/course-type/api-master-course-type-get-active-get';
import { ApiMasterCourseTypeGetActiveGet$Params } from '../fn/course-type/api-master-course-type-get-active-get';
import { apiMasterCourseTypeGetAllGet } from '../fn/course-type/api-master-course-type-get-all-get';
import { ApiMasterCourseTypeGetAllGet$Params } from '../fn/course-type/api-master-course-type-get-all-get';
import { apiMasterCourseTypeGetByCriteriaPost } from '../fn/course-type/api-master-course-type-get-by-criteria-post';
import { ApiMasterCourseTypeGetByCriteriaPost$Params } from '../fn/course-type/api-master-course-type-get-by-criteria-post';
import { CourseType } from '../models/course-type';
import { CourseTypeApiRespModel } from '../models/course-type-api-resp-model';
import { Int32ApiRespModel } from '../models/int-32-api-resp-model';

@Injectable({ providedIn: 'root' })
export class CourseTypeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterCourseTypeAddPost()` */
  static readonly ApiMasterCourseTypeAddPostPath = '/api/Master/CourseType/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCourseTypeAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCourseTypeAddPost$Response(params?: ApiMasterCourseTypeAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseTypeApiRespModel>> {
    return apiMasterCourseTypeAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCourseTypeAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCourseTypeAddPost(params?: ApiMasterCourseTypeAddPost$Params, context?: HttpContext): Observable<CourseTypeApiRespModel> {
    return this.apiMasterCourseTypeAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseTypeApiRespModel>): CourseTypeApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCourseTypeEditPost()` */
  static readonly ApiMasterCourseTypeEditPostPath = '/api/Master/CourseType/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCourseTypeEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCourseTypeEditPost$Response(params?: ApiMasterCourseTypeEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseTypeApiRespModel>> {
    return apiMasterCourseTypeEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCourseTypeEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCourseTypeEditPost(params?: ApiMasterCourseTypeEditPost$Params, context?: HttpContext): Observable<CourseTypeApiRespModel> {
    return this.apiMasterCourseTypeEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseTypeApiRespModel>): CourseTypeApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCourseTypeDeleteGet()` */
  static readonly ApiMasterCourseTypeDeleteGetPath = '/api/Master/CourseType/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCourseTypeDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCourseTypeDeleteGet$Response(params?: ApiMasterCourseTypeDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Int32ApiRespModel>> {
    return apiMasterCourseTypeDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCourseTypeDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCourseTypeDeleteGet(params?: ApiMasterCourseTypeDeleteGet$Params, context?: HttpContext): Observable<Int32ApiRespModel> {
    return this.apiMasterCourseTypeDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Int32ApiRespModel>): Int32ApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCourseTypeGetAllGet()` */
  static readonly ApiMasterCourseTypeGetAllGetPath = '/api/Master/CourseType/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCourseTypeGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCourseTypeGetAllGet$Response(params?: ApiMasterCourseTypeGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CourseType>>> {
    return apiMasterCourseTypeGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCourseTypeGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCourseTypeGetAllGet(params?: ApiMasterCourseTypeGetAllGet$Params, context?: HttpContext): Observable<Array<CourseType>> {
    return this.apiMasterCourseTypeGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CourseType>>): Array<CourseType> => r.body)
    );
  }

  /** Path part for operation `apiMasterCourseTypeGetActiveGet()` */
  static readonly ApiMasterCourseTypeGetActiveGetPath = '/api/Master/CourseType/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCourseTypeGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCourseTypeGetActiveGet$Response(params?: ApiMasterCourseTypeGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CourseType>>> {
    return apiMasterCourseTypeGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCourseTypeGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCourseTypeGetActiveGet(params?: ApiMasterCourseTypeGetActiveGet$Params, context?: HttpContext): Observable<Array<CourseType>> {
    return this.apiMasterCourseTypeGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CourseType>>): Array<CourseType> => r.body)
    );
  }

  /** Path part for operation `apiMasterCourseTypeGetByCriteriaPost()` */
  static readonly ApiMasterCourseTypeGetByCriteriaPostPath = '/api/Master/CourseType/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCourseTypeGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCourseTypeGetByCriteriaPost$Response(params?: ApiMasterCourseTypeGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CourseType>>> {
    return apiMasterCourseTypeGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCourseTypeGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCourseTypeGetByCriteriaPost(params?: ApiMasterCourseTypeGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<CourseType>> {
    return this.apiMasterCourseTypeGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CourseType>>): Array<CourseType> => r.body)
    );
  }

}
